<template>
  <!-- 发票 -->
  <div>
    <div id="enterprise-invoice">
      <div
        v-if="tabActive.tab2Active == '销项发票'"
        class="enterprise-invoice-type"
      >
        <div class="enterprise-invoice-item" id="销项发票">
          <div class="enterprise-invoice-item-title">
            <div class="title">
              销项发票 ({{ sellerInvoice.pageData.totalCount }})
            </div>
            <div style="flex: 1"></div>
            <div class="enterprise-invoice-item-title-search">
              <div class="search-item">
                <el-input
                  v-model="searchData.buyerName"
                  placeholder="请输入购买方名称"
                  @keyup.enter.native="searchSellerInvoice"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click.native.stop="searchSellerInvoice"
                  ></el-button>
                </el-input>
              </div>
              <div class="search-item">
                <el-input
                  v-model="searchData.supplierName"
                  placeholder="请输入销售方名称"
                  @keyup.enter.native="searchSellerInvoice"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click.native.stop="searchSellerInvoice"
                  ></el-button>
                </el-input>
              </div>
              <div class="search-item">
                <el-input
                  v-model="searchData.invoiceNumber"
                  placeholder="请输入发票号码"
                  @keyup.enter.native="searchSellerInvoice"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click.native.stop="searchSellerInvoice"
                  ></el-button>
                </el-input>
              </div>
              <div class="search-item">
                <el-select
                  v-model="searchData.invoiceClass"
                  placeholder="请选择发票种类"
                  @change="searchSellerInvoice"
                  clearable
                >
                  <el-option
                    v-for="item in searchData.invoiceType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <div class="search-item">
                <el-date-picker
                  v-model="searchData.date"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开票时间"
                  end-placeholder="开票时间"
                  value-format="yyyy-MM-dd"
                  @change="searchSellerInvoice"
                >
                </el-date-picker>
              </div>
            </div>
          </div>
          <div class="enterprise-invoice-item-value">
            <el-table
              :data="sellerInvoice.tableData"
              highlight-current-row
              style="width: 100%"
              border
              v-loading="loading"
              :row-style="setRowStyle"
              :header-cell-style="{
                background: '#F5F7FA',
                color: '#111A34',
                fontWeight: 700,
              }"
            >
              <el-table-column type="index" width="40" fixed> </el-table-column>
              <el-table-column
                v-for="item in sellerInvoice.tableMenu"
                :key="item.prop"
                :label="item.label"
                :width="item.width"
                :prop="item.prop"
                :fixed="item.fixed"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span
                    v-if="item.prop == 'invoiceNumber'"
                    style="color: #409eff; cursor: pointer"
                    @click="showInvoiceDetail(scope.row)"
                    >{{ scope.row[item.prop] }}</span
                  >
                  <span
                    v-else-if="item.prop == 'relateContractId'"
                    style="color: #409eff; cursor: pointer"
                    @click="handleClick(scope.row, 'relateSellerContractId')"
                    >{{ scope.row[item.prop] || "关联" }}</span
                  >
                  <span v-else>{{ scope.row[item.prop] }}</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="table-pagination">
              <el-pagination
                @current-change="handleSellerCurrentChange"
                :current-page.sync="sellerInvoice.pageData.pageIndex"
                :page-size="sellerInvoice.pageData.pageSize"
                layout="prev, pager, next"
                :total="sellerInvoice.pageData.totalCount"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="tabActive.tab2Active == '进项发票'"
        class="enterprise-invoice-type"
      >
        <div class="enterprise-invoice-item" id="进项发票">
          <div class="enterprise-invoice-item-title">
            <div class="title">
              进项发票 ({{ buyerInvoice.pageData.totalCount }})
            </div>
            <div style="flex: 1"></div>
            <div class="enterprise-invoice-item-title-search">
              <div class="search-item">
                <el-input
                  v-model="searchData.buyerName"
                  placeholder="请输入购买方名称"
                  @keyup.enter.native="searchBuyerInvoice"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click.native.stop="searchBuyerInvoice"
                  ></el-button>
                </el-input>
              </div>
              <div class="search-item">
                <el-input
                  v-model="searchData.supplierName"
                  placeholder="请输入销售方名称"
                  @keyup.enter.native="searchBuyerInvoice"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click.native.stop="searchBuyerInvoice"
                  ></el-button>
                </el-input>
              </div>
              <div class="search-item">
                <el-input
                  v-model="searchData.invoiceNumber"
                  placeholder="请输入发票号码"
                  @keyup.enter.native="searchBuyerInvoice"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click.native.stop="searchBuyerInvoice"
                  ></el-button>
                </el-input>
              </div>
              <div class="search-item">
                <el-select
                  v-model="searchData.invoiceClass"
                  placeholder="请选择发票种类"
                  @change="searchBuyerInvoice"
                  clearable
                >
                  <el-option
                    v-for="item in searchData.invoiceType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <div class="search-item">
                <el-date-picker
                  v-model="searchData.date"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开票时间"
                  end-placeholder="开票时间"
                  value-format="yyyy-MM-dd"
                  @change="searchBuyerInvoice"
                >
                </el-date-picker>
              </div>
            </div>
          </div>
          <div class="enterprise-invoice-item-value">
            <el-table
              :data="buyerInvoice.tableData"
              highlight-current-row
              style="width: 100%"
              v-loading="loading"
              border
              :row-style="setRowStyle"
              :header-cell-style="{
                background: '#F5F7FA',
                color: '#111A34',
                fontWeight: 700,
              }"
            >
              <el-table-column type="index" width="40" fixed> </el-table-column>
              <el-table-column
                v-for="item in buyerInvoice.tableMenu"
                :key="item.prop"
                :label="item.label"
                :width="item.width"
                :prop="item.prop"
                :fixed="item.fixed"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span
                    v-if="item.prop == 'invoiceNumber'"
                    style="color: #409eff; cursor: pointer"
                    @click="showInvoiceDetail(scope.row)"
                    >{{ scope.row[item.prop] }}</span
                  >
                  <span
                    v-else-if="item.prop == 'relateContractId'"
                    style="color: #409eff; cursor: pointer"
                    @click="handleClick(scope.row, 'relateBuyerContractId')"
                    >{{ scope.row[item.prop] || "关联" }}</span
                  >
                  <span
                    v-else-if="item.prop == 'relateExpenseId'"
                    style="color: #409eff; cursor: pointer"
                    @click="handleClick(scope.row, 'relateBuyerExpenseId')"
                    >{{ scope.row[item.prop] || "关联" }}</span
                  >
                  <span v-else>{{ scope.row[item.prop] }}</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="table-pagination">
              <el-pagination
                @current-change="handleBuyerCurrentChange"
                :current-page.sync="buyerInvoice.pageData.pageIndex"
                :page-size="buyerInvoice.pageData.pageSize"
                layout="prev, pager, next"
                :total="buyerInvoice.pageData.totalCount"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="my-dialog" v-if="dialogData.flag">
      <my_dialog7
        :width="dialogData.width"
        :title="dialogData.title"
        :buttonArray="dialogData.buttonArray"
        :data="dialogData.data"
        @colseDialog="colseDialog"
        @dialogOper="drawerOper"
        @buttonOper="drawerOper"
      ></my_dialog7>
    </div>
  </div>
</template>

<script>
import enterpriseTable from "@/components/enterprise-components/enterprise-table";
import * as invoiceDataByYiQi from "@/views/invoice-yiqi/js/invoice.js";
export default {
  components: {
    enterpriseTable,
  },
  props: {
    clientInfo: {
      type: Object,
      default: () => {},
    },
    tabActive: {
      type: Object,
      default: () => {},
    },
    enterpriseInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      baseInfo: {},
      loading: false,
      dialogData: {
        flag: false,
        width: "45%",
        title: "新建报销",
        buttonArray: [
          {
            text: "提交",
            active: "submit_gnjinjilu",
          },
        ],
        data: [],
      },
      searchData: {
        buyerName: "",
        supplierName: "",
        invoiceNumber: "",
        invoiceClass: "",
        invoiceType: invoiceDataByYiQi.invoiceType(),
        date: [],
      },
      buyerInvoice: {
        type: "invoiceInfo",
        tempData: {},
        tableData: [],
        tableMenu: invoiceDataByYiQi.invoiceTableDataByBuyer(),
        pageData: {
          pageIndex: 1,
          pageSize: 10,
          totalCount: 0,
        },
      },
      sellerInvoice: {
        type: "invoiceInfo",
        tempData: {},
        tableData: [],
        tableMenu: invoiceDataByYiQi.invoiceTableDataBySupplier(),
        pageData: {
          pageIndex: 1,
          pageSize: 10,
          totalCount: 0,
        },
      },

      allFunctionButtons:
        this.$featureData.getAllFunctionButtons("dispatchCheck"),
    };
  },
  watch: {
    "tabActive.tab2Active": {
      handler(newValue, oldValue) {
        this.changeTab();
      },
    },
  },

  methods: {
    getModelFeatureAuthority() {
      this.$authority.getModelFeatureAuthority(
        this,
        "dispatchCheck",
        this.allFunctionButtons,
        (data) => {
          this.allFunctionButtons = data;
        },
      );
    },
    // 获取进项发票
    getBuyerInvoice() {
      this.loading = true;
      let requestData = {
        clientId: this.clientInfo.id, // 客户id
        buyerName: this.searchData.buyerName, // 购买方名称
        supplierName: this.searchData.supplierName, // 销售方名称
        invoiceNumber: this.searchData.invoiceNumber, // 发票号码
        invoiceClass: this.searchData.invoiceClass, // 发票类型
        startDate: this.searchData.date ? this.searchData.date[0] : "", // 起始时间
        endDate: this.searchData.date ? this.searchData.date[1] : "", // 结束时间
        currentPage: this.buyerInvoice.pageData.pageIndex, // 当前页数
        pageSize: this.buyerInvoice.pageData.pageSize, // 每页条数
      };
      this.$request(
        "post",
        "/yq-invoice-input/queryYqInvoiceInput",
        requestData,
        (data) => {
          this.buyerInvoice.tableData = invoiceDataByYiQi.invoiceTableTransData(
            data.records,
          );
          this.buyerInvoice.pageData.totalCount = data.total;
          this.loading = false;
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 获取销项发票 todo 销项是crm的  但是需要拿亿企的销项和我们crm开具的进行去重补全
    getSellerInvoice() {
      this.loading = true;
      let requestData = {
        clientId: this.clientInfo.id, // 客户id
        buyerName: this.searchData.buyerName, // 购买方名称
        supplierName: this.searchData.supplierName, // 销售方名称
        invoiceNumber: this.searchData.invoiceNumber, // 发票号码
        invoiceClass: this.searchData.invoiceClass, // 发票类型
        startDate: this.searchData.date ? this.searchData.date[0] : "", // 起始时间
        endDate: this.searchData.date ? this.searchData.date[1] : "", // 结束时间
        currentPage: this.sellerInvoice.pageData.pageIndex, // 当前页数
        pageSize: this.sellerInvoice.pageData.pageSize, // 每页条数
      };
      this.$request(
        "post",
        "/yq-invoice-output/queryYqInvoiceOutput",
        requestData,
        (data) => {
          this.sellerInvoice.tableData =
            invoiceDataByYiQi.invoiceTableTransData(data.records);
          this.sellerInvoice.pageData.totalCount = data.total;
          this.loading = false;
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    changeTab() {
      switch (this.tabActive.tab2Active) {
        case "销项发票":
          this.getSellerInvoice();
          break;
        case "进项发票":
          this.getBuyerInvoice();
          break;
        default:
          break;
      }
    },
    handleClick(row, prop) {
      switch (prop) {
        case "relateSellerContractId":
          this.dialogData.title = "选择客户合同";
          this.dialogData.width = "800px";
          this.dialogData.buttonArray = [];
          this.dialogData.data = [
            {
              type: "",
              title: "",
              data: {},
            },
          ];
          this.dialogData.flag = true;
          break;
        case "relateBuyerContractId":
          this.dialogData.title = "选择供应商合同";
          this.dialogData.width = "800px";
          this.dialogData.buttonArray = [];
          this.dialogData.data = [
            {
              type: "",
              title: "",
              data: {},
            },
          ];
          this.dialogData.flag = true;
          break;
        case "relateBuyerExpenseId":
          this.dialogData.title = "选择报销单";
          this.dialogData.width = "800px";
          this.dialogData.buttonArray = [];
          this.dialogData.data = [
            {
              type: "",
              title: "",
              data: {},
            },
          ];
          this.dialogData.flag = true;
          break;
        case "cancel":
          this.dialogData.flag = false;
          break;
        default:
          break;
      }
    },
    colseDialog() {
      this.dialogData.flag = false;
    },
    showInvoiceDetail(row) {
      // 发票预览
      this.dialogData.title = "发票信息";
      this.dialogData.width = "1150px";
      this.dialogData.buttonArray = [];
      this.dialogData.data = [
        {
          type: "invoice-yiqi",
          title: "",
          data: row,
        },
      ];
      this.dialogData.flag = true;
    },
    handleBuyerCurrentChange() {
      this.getBuyerInvoice();
    },
    handleSellerCurrentChange() {
      this.getSellerInvoice();
    },
    searchSellerInvoice() {
      this.sellerInvoice.pageData.pageIndex = 1;
      this.getSellerInvoice();
    },
    searchBuyerInvoice() {
      this.buyerInvoice.pageData.pageIndex = 1;
      this.getBuyerInvoice();
    },
    toDecimal2(num) {
      num = Number(num) || 0;
      return Number(num.toFixed(2));
    },
    // 行样式方法
    setRowStyle({ row }) {
      if (this.toDecimal2(row.invoiceTotalPrice) >= 0) {
        return {
          backgroundColor: "#FFFFFF",
          height: "60px",
        };
        // return {
        //   backgroundColor: '#fff2f0',  // 浅红底色
        //   color: '#ff4d4f'
        // }
      } else {
        return {
          color: "red",
          height: "60px",
        };
      }
    },
  },
  mounted() {
    console.log("this.clientInfo", this.clientInfo);
    this.baseInfo = JSON.parse(sessionStorage.getItem("userData"));
    this.getModelFeatureAuthority();
    this.changeTab();
  },
};
</script>

<style lang="less" scoped>
#enterprise-invoice {
  width: 100%;
  background-color: #fff;
  .enterprise-invoice-type {
    width: 100%;
    .enterprise-invoice-item {
      width: 100%;
      margin-top: 32px;
      scroll-margin-top: 180px;
      &:first-child {
        margin-top: 0;
      }
      .enterprise-invoice-item-title {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;
        font-weight: 500;
        font-size: 16px;
        line-height: 28px;
        .title {
          // 不换行
          white-space: nowrap;
          margin-right: 20px;
        }
        .enterprise-invoice-item-title-search {
          display: flex;
          .search-item {
            margin-right: 5px;
            max-width: 200px;
          }
        }
      }
      .enterprise-invoice-item-tag {
        display: flex;
        margin: 12px 0;
        .tag {
          font-size: 14px;
          color: #777e95;
          cursor: pointer;
          height: 28px;
          padding: 0 12px;
          line-height: 28px;
          cursor: pointer;
          border-radius: 14px;
        }
        .is-active {
          color: #327bf9;
          background: #eaf2ff;
        }
        .is-disabled {
          color: #c3c8da;
          cursor: not-allowed;
        }
      }
      .enterprise-invoice-item-value {
        width: 100%;
        .text {
          width: 100%;
          padding: 15px 23px;
          font-size: 14px;
          line-height: 24px;
          text-align: left;
          box-sizing: border-box;
          background: #f6f8fb
            url(https://51nbimg.u51.com/62c9ea111656463a90e8c968177a5d5d.png)
            right bottom / 102px 102px no-repeat;
        }
        .table-text {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          .table-text-item {
            width: 100%;
            height: 100%;
            display: flex;
            font-size: 14px;
            border: 1px solid #eff1f8;
            color: #111a34;

            .table-text-item-title {
              background-color: #f9fafc;
              width: 145px;
              min-width: 145px;
              text-align: right;
              padding: 13px 16px;
              box-sizing: border-box;
              color: #777e95;
              border-right: 1px solid #eff1f8;
            }
            .table-text-item-value {
              width: 80%;
              padding: 13px 16px;
              box-sizing: border-box;
              text-align: left;
              word-wrap: break-word;
              word-break: normal;
            }
          }
          .gather {
            .table-text-item-line {
              display: flex;
              &:last-child .table-text-item-value {
                border-bottom: 0;
              }
              .table-text-item-value {
                border-right: 1px solid #eff1f8;
                border-bottom: 1px solid #eff1f8;
                &:nth-child(even) {
                  border-right: 0;
                }
              }
            }
          }
        }
      }
    }
  }
  .activeColor {
    color: #327bf9 !important;
    cursor: pointer;
  }
  .table-pagination {
    margin-top: 16px;
    text-align: right;
  }
}
</style>
